module.exports = __webpack_public_path__ + "static/michels-logo-70693bc0497679f4b75e1c96000e083c.jpg";